
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mon-compte/preferences",
      function () {
        return require("private-next-pages/mon-compte/preferences.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mon-compte/preferences"])
      });
    }
  